// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","form":"styles_form__lwg8e","prompt":"styles_prompt__RCfEN"};